<div class="option-stimulus__item" [ngClass]="align()" [class.no-border]="noBorder()">
  <div class="option-stimulus__item-media" (click)="clicked.emit()">
    <button mat-icon-button title="Expand" class="option-stimulus__item-expand" (click)="expanded$.set(true); $event.stopPropagation()">
      <fa-icon [icon]="faUpRightAndDownLeftFromCenter"></fa-icon>
    </button>

    <empathy-media-view [media]="media()"></empathy-media-view>
  </div>
  <ng-content></ng-content>
</div>

@if (expanded$()) {
  <div class="option-stimulus__expanded">
    <div class="option-stimulus__expanded__overlay"></div>
    <div class="option-stimulus__expanded__media">
      <div class="option-stimulus__expanded__media-header">
        <span class="fs__md fw__400 option-stimulus__expanded__media-header-text" [innerHTML]="altText() || media().name"></span>
        <button mat-icon-button title="Close expanded media" color="light" (click)="expanded$.set(false)">
          <fa-icon [icon]="faClose"></fa-icon>
        </button>
      </div>

      <empathy-media-view [media]="media()" [isExpanded]="true"></empathy-media-view>
    </div>
  </div>
}
